<div class="title">
    <span>{{ 'translation:Unsaved changes' | i18next}}</span>
</div>
<div class="dialog-content">
    <div class="text-container">
        {{ 'translation:Unsaved changes dialog' | i18next}}
    </div>
</div>
<mat-dialog-actions>
    <button matButton [ngClass]="['secondary-button']" (click)="closeDialog()">{{ 'translation:Cancel' | i18next}}</button>
    <button matButton [ngClass]="['primary-button', 'continue-button-dialog']" (click)="continue()">{{ 'translation:Yes' |
        i18next }}</button>
</mat-dialog-actions>